import { useEffect, useState } from "react";
import { useAuth } from "@clerk/clerk-react";
import { supabase } from "@/integrations/supabase/client";

interface Props {
  path: string;
  className?: string;
  alt?: string;
}

/** Renders a private Manager Notes image via a short-lived signed link. */
const NoteImage = ({ path, className, alt = "Note attachment" }: Props) => {
  const { getToken } = useAuth();
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const token = await getToken();
        const { data } = await supabase.functions.invoke("note-image-url", {
          headers: token
            ? { Authorization: `Bearer ${token}`, "X-Clerk-Authorization": `Bearer ${token}` }
            : {},
          body: { path },
        });
        if (active && (data as any)?.success) setUrl((data as any).url as string);
      } catch {
        /* image simply stays hidden */
      }
    })();
    return () => {
      active = false;
    };
  }, [path, getToken]);

  if (!url) return null;
  return <img src={url} alt={alt} loading="lazy" className={className} />;
};

export default NoteImage;
